import posthog from 'posthog-js'

import { POSTHOG_EVENTS } from '../constants/posthog'

const { REACT_APP_API_ENV } = process.env
const mappedEvents = new Set(Object.values(POSTHOG_EVENTS))

export const captureEvent = (eventName, properties = {}) => {
  if (!mappedEvents.has(eventName)) return null

  const globalEventProperties = {
    sistema: 'principiapay_app_aluno',
    origem_evento: 'client',
    ambiente: REACT_APP_API_ENV,
    bu: 'principiapay'
  }

  posthog.capture(eventName, { ...properties, ...globalEventProperties })
}

/**
 * Grava o parceiro (IES) do produto selecionado como super property: todo
 * evento seguinte leva partnerId/partnerName, as mesmas chaves do checkout
 * (fe_provi_pay_v3).
 *
 * Não usamos `posthog.group`: cada chamada com propriedades emitia um
 * `$groupidentify` e todo evento com `$groups` era cobrado de novo em group
 * analytics. `register` não envia evento nenhum.
 *
 * As chaves são limpas antes da busca: se ela falhar, os eventos do produto
 * novo não podem herdar o parceiro do produto escolhido antes. Se duas
 * seleções se sobrepuserem, só a mais recente grava: uma resposta atrasada da
 * anterior é descartada. Nunca lança.
 *
 * @param {() => Promise<{ PartnerId: number|string, partnerName?: string }>} buscarParceiro
 */
let ultimaSelecaoParceiro = 0

export const registrarParceiro = async buscarParceiro => {
  ultimaSelecaoParceiro += 1
  const selecao = ultimaSelecaoParceiro

  try {
    posthog.unregister('partnerId')
    posthog.unregister('partnerName')

    const { PartnerId, partnerName } = await buscarParceiro()
    if (selecao !== ultimaSelecaoParceiro) return
    if (PartnerId === undefined || PartnerId === null) return

    posthog.register({
      partnerId: String(PartnerId),
      ...(partnerName ? { partnerName } : {})
    })
  } catch (err) {
    // telemetria nunca derruba a navegação
  }
}

/**
 * Remove do storage do PostHog só o grupo legado `partner` (do antigo
 * `posthog.group('partner', ...)`), preservando qualquer outro grupo. Nunca lança.
 */
export const removerGrupoLegadoPartner = () => {
  try {
    const grupos = posthog.getGroups() || {}
    if (!Object.prototype.hasOwnProperty.call(grupos, 'partner')) return

    const { partner, ...outros } = grupos
    if (Object.keys(outros).length) posthog.register({ $groups: outros })
    else posthog.unregister('$groups')
  } catch (err) {
    // telemetria nunca derruba o boot
  }
}
